export const MY_STORIES = '/my-stories';
export const TEAMS = '/teams';
export const SETTINGS = '/settings';
export const FORGOTTEN_PASSWORD = '/forgot-password';
